'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC } from 'react';
import { BEAM_LAYERS, MOBILE_BEAM_LABELS } from '@/components/ServicesLobbyPage/BrandEvolutionSection/const';
import { BeamLayerId } from '@/components/ServicesLobbyPage/BrandEvolutionSection/types';
import useDevice from '@/hooks/useDevice';
import css from './style.module.scss';
const BEAM_LAYER_CLASS_NAMES: Record<BeamLayerId, string> = {
  '01': css.beamLayer01,
  '02': css.beamLayer02,
  '03': css.beamLayer03,
  '04': css.beamLayer04,
  '05': css.beamLayer05,
  '06': css.beamLayer06
};
const MOBILE_LABEL_CLASS_NAMES: Record<BeamLayerId, string> = {
  '01': css.mobileLabel01,
  '02': css.mobileLabel02,
  '03': css.mobileLabel03,
  '04': css.mobileLabel04,
  '05': css.mobileLabel05,
  '06': css.mobileLabel06
};
const EvolutionBeams: FC = () => {
  const $ = _c(2);
  const device = useDevice();
  const isMobile = device === "mobile";
  let t0;
  if ($[0] !== isMobile) {
    t0 = isMobile ? <div aria-hidden={true} className={css.mobileRoot}>{MOBILE_BEAM_LABELS.map(_temp)}<img className={css.mobileLayer} src="/assets/images/brand-evolution-section/beams-mobile.svg" alt="" /></div> : <div aria-hidden={true} className={css.desktopRoot}>{BEAM_LAYERS.map(_temp2)}</div>;
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default EvolutionBeams;
function _temp(t0) {
  const {
    id,
    text
  } = t0;
  return <p key={id} className={clsx(css.mobileLabel, MOBILE_LABEL_CLASS_NAMES[id])}>{text}</p>;
}
function _temp2(t0) {
  const {
    id: id_0,
    src
  } = t0;
  return <img key={id_0} className={clsx(css.desktopLayer, BEAM_LAYER_CLASS_NAMES[id_0])} src={src} alt="" />;
}